import styled from 'styled-components'
import { Space as SpaceAntDesign } from 'antd'

const Space = styled(SpaceAntDesign)`
  width: 100%;
  margin-top: ${(props) => props.marginTop};
`

export default Space
